
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { DEFAULT_UNIT_TYPES, UnitInputValue } from "@/types/unit";
import UnitInput from "./UnitInput/UnitInput.vue";
import VariableBoundInput from "@/oxygen/variables/VariableBoundInput.vue";

/* these types suck ass and are not solid at all */

type SpacingInputValue = {
  left?: UnitInputValue;
  right?: UnitInputValue;
  top?: UnitInputValue;
  bottom?: UnitInputValue;
};

const SPACING_DIRECTIONS = ["left", "right", "top", "bottom"] as const;
/* Use the string values from array above to define a type */
type SpacingInputKey = (typeof SPACING_DIRECTIONS)[number];

@Component({
  components: { VariableBoundInput, UnitInput }
})
export default class SpacingComplex extends Vue {
  @Prop({
    default: null
  })
  value!: SpacingInputValue | null;

  @Prop({ default: false })
  acceptsVariable!: boolean;

  @Prop()
  placeholder?: {
    left: string;
    right: string;
    top: string;
    bottom: string;
  };

  applyToAll = false;

  lastTouchedSpacingInput: SpacingInputKey = "top";

  get unitOptions() {
    return { types: DEFAULT_UNIT_TYPES };
  }

  getValueForSide(side: SpacingInputKey) {
    return this.value && side in this.value ? this.value[side] : null;
  }

  edit(unitInputValue: UnitInputValue, key: SpacingInputKey) {
    this.lastTouchedSpacingInput = key;

    if (this.applyToAll) {
      this.applyUnitInputValueToAllAndEmit(unitInputValue);
    } else {
      const newValue: SpacingInputValue = {
        ...this.value,
        [key]: unitInputValue
      };

      this.$emit("input", newValue);
    }
  }

  toggleApplyToAll() {
    this.applyToAll = !this.applyToAll;

    if (this.applyToAll) {
      this.applyUnitInputValueToAllAndEmit(
        this.value?.[this.lastTouchedSpacingInput]
      );
    }
  }

  setLastTouchedSpacingInput(key: SpacingInputKey) {
    this.lastTouchedSpacingInput = key;
  }

  applyUnitInputValueToAllAndEmit(unitInputValue: UnitInputValue | undefined) {
    const newValue: SpacingInputValue = {};
    SPACING_DIRECTIONS.forEach(key => {
      newValue[key] = unitInputValue;
    });
    this.$emit("input", newValue);
  }

  maybeToggleAll(event: KeyboardEvent) {
    if (event.key !== "=") return;

    const container = this.$refs.container as HTMLElement;
    if (!container.contains(document.activeElement)) return;

    event.preventDefault();
    this.toggleApplyToAll();
  }

  mounted() {
    window.addEventListener("keydown", this.maybeToggleAll);
  }

  beforeDestroy() {
    window.removeEventListener("keydown", this.maybeToggleAll);
  }
}
